<template>
  <div>
    <el-form :disabled="readonly" class="section top" style="flex-direction: row;min-width: 1600px;">
      <el-checkbox v-model="job.warehousing" no="1" @change="loadingTerm_Change('warehousing')">{{ $t('SeaExport.Storage') }}</el-checkbox>
      <el-checkbox v-model="job.comercialInspectation" no="2">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
    </el-form>
    <div class="section top" style="min-width: 1600px;">
      <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
      <el-form
        :disabled="readonly"
        :inline="true"
        label-width="100px"
        label-position="left"
      >
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
          <el-input v-model="job.jobNo" no="3" :disabled="true" class="job-no-color" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_WarehouseNo')">
          <el-input v-model="job.warehouseNo" no="4" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.quotationNum')">
          <el-input no="5" :value="job.quotationNo" class="input2" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('Payment.businessReferenceNumber')">
          <cargo-input v-model="job.customerRefNo" no="6" :trim="true" />
        </el-form-item>
      </el-form>
      <div>
        <div>
          <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('Payment.consignationCompany') }}</span>
              <cargo-sales-company-select
                v-if="accountObjectControlMode === 2"
                no="7"
                :disabled="!(!job.mbl&&electricBusinessBtnEnable)"
                :method-params="{customer:true,active:true}"
                :check-credit="true"
                :job="job"
                :default-value="job.customerId||''"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
              />
              <cargo-company-select
                v-else
                no="7"
                :disabled="!(!job.mbl&&electricBusinessBtnEnable)"
                :method-params="{customer:true,active:true}"
                :check-credit="true"
                :job="job"
                :default-value="job.customerId||''"
                :static-options="customerCmpList"
                :placeholder="$t('SeaExport.RequiredItem')"
                @change="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.contactPerson')">
              <el-select
                v-model="job.customerContact"
                no="8"
                :disabled="!electricBusinessBtnEnable"
                filterable
                :allow-create="true"
                placeholder=""
                @change="tfLinkman_closeHandler"
              >
                <el-option
                  v-for="(item,index) in contactList"
                  :key="index"
                  :label="item.contactPerson"
                  :value="item.contactPerson"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Tel')">
              <el-input
                v-model="job.contactTelephone"
                no="9"
                :disabled="!electricBusinessBtnEnable"
                maxlength="32"
              />
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Fax')">
              <el-input
                v-model="job.contactFax"
                no="10"
                :disabled="!electricBusinessBtnEnable"
                maxlength="32"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left">
            <el-form-item class="blue">
              <span slot="label" class="blue">{{ $t('Payment.sales') }}</span>
              <cargo-user-select
                no="11"
                :disabled="lockSales||!(!job.trustFromJob&&electricBusinessBtnEnable&&(!validateCustomerSales||(isSpecifiedSalesBusiness&&validateCustomerSales)))"
                :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="job.sales||''"
                :static-options="salesList"
                :placeholder="$t('SeaExport.RequiredItem')"
                @change="txtSales_changeHandler"
              />
            </el-form-item>
            <el-form-item class="blue">
              <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input v-model="txtSalesOffice" no="12" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" />
            </el-form-item>
            <el-form-item :label="$t('Payment.customerService')">
              <cargo-user-select
                no="13"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'csr',officeId:job.opOffice}"
                :default-value="job.csr||''"
                :static-options="userPortRoleData.csr || csrList"
                placeholder=" "
                @change="csrChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')" label-width="100px">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                class="input2"
                placeholder=" "
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHc ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left">
            <el-form-item :label="$t('SeaExport.OperateType')">
              <cargo-advance-select
                no="14"
                filterable
                :select-type="TYPE_NAMES.local_cache_AirExportConstants$BUSINESS_MODELS"
                :default-value="job.operateType"
                :clearable="false"
                @parentCallBack="p=>{job.operateType=p.value;onOperateTypeChange()}"
              />
            </el-form-item>
            <el-form-item :label="$t('FileHistory.operation')">
              <cargo-user-select
                no="15"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOfficeId}"
                :default-value="job.op||''"
                placeholder=" "
                :static-options="userPortRoleData.op"
                @change="txtOPChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.operationDepartment')">
              <cargo-department-select
                no="16"
                :disabled="Boolean(job.trustFromJob)"
                :office-id="job.opOffice"
                :department-id="job.opDepartment"
                placeholder=" "
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="17"
                :disabled="isEntrustOrder()"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.opOffice||''"
                placeholder=" "
                @parentCallBack="p=>{job.opOffice=p.value;opOfficeChargeHandler()}"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left">
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="18"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                :static-options="cargoSalesList"
                placeholder=" "
                @change="cargoSalesChargeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.Documents')">
              <cargo-user-select
                no="104"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'doc',officeId:$store.getters.currentOfficeId}"
                :default-value="job.dc||''"
                :static-options="userPortRoleData.doc || dcList"
                placeholder=" "
                @change="dcChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                no="19"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.planner')">
              <cargo-user-select
                no="20"
                :method-params="{category:'role',shape:'airline',officeId:currentOffice.code==='HB'?null:currentOffice.officeId}"
                :default-value="job.planner||''"
                placeholder=" "
                :static-options="userPortRoleData.airline"
                @change="txtPlannerChangeHandler"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left">
            <el-form-item :label="$t('Message.Customer_Service')">
              <cargo-department-select
                no="csrDepartment"
                class="input2"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-advance-select
                no="csrOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.csrOffice||''"
                @parentCallBack="p=>{job.csrOffice=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.Documentation_Department')">
              <cargo-department-select
                no="dcDepartment"
                class="input2"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-advance-select
                no="dcOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.dcOffice||''"
                @parentCallBack="p=>{job.dcOffice=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left">
            <el-form-item :label="$t('Payment.itemNo')" :class="poNoRed?'poNoClass':''">
              <el-input v-if="!openProjectConfig" v-model="job.poNo" no="21" />
              <cargo-project-select
                v-if="openProjectConfig"
                no="22"
                :default-value="job.poNo"
                :customer-id="job.customerId"
                :is-linked="isProjectLinkedCustomer"
                @change="changeProject"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineDepartment')">
              <cargo-department-select
                no="plannerDepartment"
                class="input2"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-advance-select
                no="plannerOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.plannerOffice||''"
                @parentCallBack="p=>{job.plannerOffice=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="openProjectConfig" :label="$t('SeaExport.ProjectName')">
              <el-input v-model="job.projectName" no="23" :disabled="true" />
            </el-form-item>
            <el-form-item v-if="openProjectConfig" :label="$t('SeaExport.ProjectBatch')">
              <el-input v-model="job.projectBatch" no="24" />
            </el-form-item>
          </el-form>
          <el-form v-if="isAddUserDefinedRoles" :disabled="readonly" :inline="true" label-width="100px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                no="25"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :placeholder="$t('SeaExport.RequiredItem')"
                :static-options="userPortRoleData.userDefinedRole1"
                @change="userDefinedRoleId1Handler"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                no="26"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :placeholder="$t('SeaExport.RequiredItem')"
                :static-options="userPortRoleData.userDefinedRole2"
                @change="userDefinedRoleId2Handler"
              />
            </el-form-item>
          </el-form>
        </div>
        <div v-show="job.preverifyState===3" style="display: flex">
          <span style="width: 100px;">{{ $t('CargoMsg.Cargo_DenialReason') }}</span>
          <el-input v-model="job.bookingRefuseNote" no="27" type="textarea" style="width: 260px" :rows="3" :disabled="true" />
        </div>
      </div>
    </div>
    <div class="section" style="min-width: 1600px;">
      <span class="title">{{ $t('CargoMsg.Cargo_ShippingInformation') }}</span>
      <div class="form-item-w260" style="display: flex;flex-direction: row;">
        <el-form
          :disabled="readonly"
          label-width="110px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.Shipper')" class="auto-width">
            <cargo-company-select
              no="28"
              :disabled="readonly"
              :method-params="{shipper:true,active:true}"
              :default-value="job.shipperId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateShipperList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="shipperChange"
            />&nbsp;
            <el-button
              no="29"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="job['shipperLine'+i]"
              no="30"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture') }}</span>
            <el-date-picker v-model="job.etd" no="31" type="date" value-format="yyyy-MM-dd" clearable :placeholder="$t('SeaExport.RequiredItem')" @input="etdChange" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ArrivalTime')">
            <el-date-picker v-model="job.eta" no="32" type="date" value-format="yyyy-MM-dd" clearable />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
            <el-input
              v-model="job.dispatchingPlace"
              no="33"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.LoadingPort') }}</span>
            <div style="display: flex;justify-content: space-between">
              <el-input
                v-model="job.loadingPortCode"
                no="34"
                :disabled="true"
                class="short-el-input"
                style="width: 60px;"
              />
              <cargo-advance-select
                no="35"
                filterable
                :select-type="TYPE_NAMES.basic_data_Airport"
                :default-value="job.loadingPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"
                class="port-item"
                @parentCallBack="p=>{job.loadingPortCode=p.value;onLoadingPortCodeChange()}"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('Payment.portOfDestination')">
            <span slot="label" class="blue">{{ $t('Payment.portOfDestination') }}</span>
            <div style="display: flex;justify-content: space-between">
              <el-input
                v-model="job.destinationPortCode"
                no="36"
                :disabled="true"
                class="short-el-input"
                style="width: 60px;"
              />
              <cargo-advance-select
                no="37"
                filterable
                :select-type="TYPE_NAMES.basic_data_Airport"
                :default-value="job.destinationPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"
                class="port-item"
                @parentCallBack="destinationPortCodeChange"
              />
            </div>
          </el-form-item>
          <el-form-item label=" ">
            <div style="display: flex;justify-content: space-between">
              <el-checkbox v-model="job.transfering" no="38">{{ $t('SeaExport.Transit') }}</el-checkbox>
              <el-button
                no="39"
                :disabled="!job.transfering"
                type="primary"
                style="width: 100%;"
                @click="showTransitPortDialog"
              >{{ $t('SeaExport.EnterTransitInfo') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FinalPlaceOfDelivery')">
            <div style="display: flex;justify-content: space-between">
              <el-input v-model="job.destinationPlace" no="40" @input="val=> job.destinationPlace = StrUtils.toUpperCase(val)" />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CargoType')">
            <cargo-advance-select
              no="41"
              filterable
              :select-type="TYPE_NAMES.basic_data_CargoType"
              :method-params="{air:true}"
              :default-value="job.cargoType"
              :clearable="false"
              @parentCallBack="p=>{job.cargoType=p.value;onCargoTypeChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ArrivalMethod')">
            <cargo-advance-select
              no="42"
              filterable
              :select-type="TYPE_NAMES.local_cache_AirExportConstants$SUFFY_TYPES"
              :tag-name="isZh ? 'chineseName' : 'englishName'"
              :default-value="job.loadingTerm"
              :placeholder="$t('Message.PleaseSelect')"
              @parentCallBack="loadingTermChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CargoTerminalOperation')">
            <cargo-advance-select
              no="cargoTerminalOperation"
              :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
              :method-params="{dataType:0, deletionFlag: false}"
              filterable
              :clearable="true"
              :default-value="job.cargoTerminalOperation"
              @parentCallBack="cargoTerminalOperationChange"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EstimatedDeliveryDate')">
            <el-date-picker v-model="job.estimatedDeliveryDate" :disabled="readonly || !job.cargoTerminalOperation" no="estimatedDeliveryDate" type="date" value-format="yyyy-MM-dd" clearable />
          </el-form-item>
          <el-form-item :label="$t('queryJob.masterBLFreightTerm')">
            <cargo-advance-select
              no="43"
              filterable
              :select-type="TYPE_NAMES.basic_data_PaymentTerm"
              :default-value="job.paymentTermMBL"
              :clearable="false"
              @parentCallBack="p=>{job.paymentTermMBL=data.value;portChange()}"
            />
          </el-form-item>
          <el-form-item v-show="job.operateType!==2" :label="$t('queryJob.HBLFreightClause')">
            <cargo-advance-select
              no="44"
              :select-type="TYPE_NAMES.basic_data_PaymentTerm"
              filterable
              :clearable="false"
              :default-value="job.paymentTermHBL"
              :allow-create="true"
              @parentCallBack="p=>{job.paymentTermHBL=p.value;portChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SolicitationType')">
            <cargo-advance-select
              no="45"
              filterable
              :select-type="TYPE_NAMES.local_cache_CargoSource"
              :default-value="job.cargoSource"
              :clearable="false"
              @parentCallBack="p=>{job.cargoSource=p.value;selectFieldChangeHandler();cargoSouceChange()}"
            />
          </el-form-item>
          <el-form-item v-if="job.cargoSource === 'NC'" id="agentRefNo" :label="$t('SeaExport.NCReferenceNo')">
            <el-input v-model="job.agentRefNo" no="agentRefNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              ref="customJobType"
              no="46"
              filterable
              :select-type="TYPE_NAMES.basic_data_CutomJobType"
              :method-params="{type:job.lob, active: true}"
              :default-value="job.customJobType"
              :placeholder="$t('Message.PleaseSelect')"
              @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.destinationAgent')">
            <cargo-advance-select
              no="47"
              :select-type="TYPE_NAMES.basic_data_Company"
              filterable
              :method-params="{overseaAgent:true,active:true}"
              :default-value="job.destinationAgent||''"
              placeholder=" "
              @parentCallBack="txtDestinationAgentChangeHandler"
            />
          </el-form-item>
          <el-form-item v-show="job.cargoSource==='NC'">
            <span slot="label" class="blue">{{ $t('queryJob.nominatedAgent') }}</span>
            <cargo-company-select
              no="48"
              :method-params="{designationAgent:true,active:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.designationAgent||''"
              tag-name="englishName"
              placeholder=" "
              @change="txtDesignationAgentChangeHandler"
            />
          </el-form-item>
          <el-form-item v-show="bookingAgentVisible" :label="$t('queryJob.bookingAgent')">
            <cargo-advance-select
              no="49"
              filterable
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{bookingAgent:true,companyLob:'airExport',active:true}"
              :default-value="job.bookingAgent || ''"
              placeholder=" "
              @parentCallBack="bookingAgentChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.AirlineCompany')">
            <cargo-advance-select
              no="50"
              filterable
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{airCmp:true,active:true}"
              :default-value="job.carrierId||''"
              placeholder=" "
              @parentCallBack="p=>{job.carrierId=p.value||0;onCarrierIdChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Flight')">
            <el-input v-model="job.voyageFlight" no="51" @change="voyageFlightCheckHandler" />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="130px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.Consignee')" class="auto-width">
            <cargo-company-select
              no="52"
              :disabled="readonly"
              :method-params="{consignee:true,active:true}"
              :default-value="job.consigneeId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateConsigneeList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="consigneeChange"
            />&nbsp;
            <el-button
              no="53"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="job['consigneeLine'+i]"
              no="54"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
          <el-form-item class="auto-width" :label="$t('SeaExport.CommissionedNumberOfPackages')">
            <auto-number-input
              v-model="job.quantityContract"
              no="55"
              :precision="0"
              :min="0"
              style="width: 230px"
            />
            <!-- <el-input-number
              v-model="job.quantityContract"
              :controls="false"
              :precision="0"
              style="width: 230px"
            /> -->
          </el-form-item>
          <div v-show="openImperial">
            <el-form-item class="auto-width" :label="$t('SeaExport.CommissionedGrossWeight') + '(LB)'">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.weightContractImperial"
                  no="weightContractImperial"
                  :precision="3"
                  :min="0"
                  style="width: 230px"
                  @change="doWeightChangeHandler(true)"
                />
                <div style="font-size: 12px;">LB</div>
              </div>
            </el-form-item>
            <el-form-item class="auto-width" :label="$t('SeaExport.CommissionedVolume') + '(CFT)'">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.cubAgeContractImperial"
                  no="cubAgeContractImperial"
                  :precision="3"
                  :min="0"
                  style="width: 230px"
                  @change="doCuAgeChangeHandler(true)"
                />
                <div style="font-size: 12px;">CFT</div>
              </div>
            </el-form-item>
          </div>
          <div v-show="!openImperial">
            <el-form-item class="auto-width" :label="$t('SeaExport.CommissionedGrossWeight')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.weightContract"
                  no="56"
                  :precision="3"
                  :min="0"
                  style="width: 230px"
                  @change="doWeightChangeHandler(false)"
                />
                <div style="font-size: 12px;">KGS</div>
              </div>
            </el-form-item>
            <el-form-item class="auto-width" :label="$t('SeaExport.CommissionedVolume')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.cubageContract"
                  no="57"
                  :precision="3"
                  :min="0"
                  style="width: 230px"
                  @change="doCuAgeChangeHandler(false)"
                />
                <div style="font-size: 12px;">M³</div>
              </div>
            </el-form-item>
          </div>
          <el-form-item class="auto-width" :label="$t('queryJob.CommissionedDensity')">
            <auto-number-input
              v-model="job.densityContract"
              no="58"
              :precision="3"
              :min="0"
              style="width: 230px"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')">
            <cargo-packing-select
              no="59"
              :disabled="readonly"
              :default-value="job.packing"
              placeholder=" "
              @change="p=>{job.packing=p.value}"
            />
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label style="width: 115px">{{ $t('SeaExport.pbProportion') }}</label>
              <div class="short-input" style="margin-left: 15px" :class="readonly ? 'short-input-disabled' : ''">
                <el-select
                  v-if="splitBubbleCollectionFormat"
                  :value="job.pbProportion||''"
                  no="60"
                  clearable
                  :filterable="!pbProportionCheck"
                  :allow-create="!pbProportionCheck"
                  @focus="onPbProportionFocus"
                  @input="val=>{job.pbProportion=val}"
                >
                  <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
                <template v-else>
                  <el-input-number
                    v-model="job.pbProportion"
                    no="60"
                    style="margin-right: 0px"
                    controls-position="right"
                    :precision="0"
                    :min="0"
                    :max="100"
                  />
                  <span>%</span>
                </template>
              </div>
              <label style="width: 64px">{{ $t('SeaExport.pbProportion2') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <el-select
                  v-if="splitBubbleCollectionFormat"
                  :value="job.pbProportion2||''"
                  no="61"
                  clearable
                  :filterable="!pbProportion2Check"
                  :allow-create="!pbProportion2Check"
                  @focus="onPbProportion2Focus"
                  @input="val=>{job.pbProportion2=val}"
                >
                  <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
                <template v-else>
                  <el-input-number
                    v-model="job.pbProportion2"
                    no="61"
                    controls-position="right"
                    :precision="0"
                    :min="0"
                    :max="100"
                  />
                  <span>%</span>
                </template>
              </div>
            </div>
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label :style="{width: isZh ? '130px' : '90px'}">{{ $t('SeaExport.Pieces') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.insideQuantity"
                  no="62"
                  :precision="0"
                  :min="0"
                />
              </div>

              <!-- <el-input-number
                v-model="job.insideQuantity"
                :controls="false"
                :precision="0"
                style="width: 108px;"
              /> -->
              <label :style="{width: isZh ? '65px' : '105px'}">{{ $t('SeaExport.ChargedWeight') }}</label>
              <div v-show="openImperial" class="short-input short-input-disabled">
                <el-input-number
                  v-model="job.chargeWeightImperial"
                  no="chargeWeightImperial"
                  :controls="false"
                  :precision="3"
                  :disabled="true"
                />
                <span>LB</span>
              </div>
              <div v-show="!openImperial" class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <el-input-number
                  v-model="job.chargeWeight"
                  no="63"
                  :controls="false"
                  :precision="3"
                />
                <span>M/T</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PiecesType')">
            <cargo-packing-select
              no="64"
              :disabled="readonly"
              :default-value="job.insidePacking"
              placeholder=" "
              @change="p=>{job.insidePacking=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Size')">
            <el-input
              v-model="job.measurements"
              no="65"
              type="textarea"
              :rows="3"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Size'),job.measurements,val=>{job.measurements=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_FrontEndWarehouseOperation')">
            <cargo-advance-select
              no="frontEndWarehouseOperation"
              :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
              :method-params="{dataType:1, deletionFlag: false}"
              filterable
              :clearable="true"
              :default-value="job.frontEndWarehouseOperation"
              @parentCallBack="p=>{job.frontEndWarehouseOperation=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EstimatedWarehousingTime')">
            <el-date-picker
              v-model="job.estimatedDateOfWarehousinge"
              no="66"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EstimatedDeliveryTime')">
            <el-date-picker
              v-model="job.estimatedDeliveryTime"
              no="67"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TradeTerms')">
            <cargo-advance-select
              no="68"
              :select-type="TYPE_NAMES.basic_data_IncoTerm"
              filterable
              :clearable="false"
              :default-value="job.incoTerm"
              @parentCallBack="p=>{job.incoTerm=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingProperty')">
            <el-select v-model="job.bookingTerm" no="69" :clearable="false" size="mini">
              <el-option
                v-for="(item,index) in bookingTerms"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsDeclarationWay')">
            <cargo-advance-select
              no="70"
              filterable
              :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS"
              :default-value="job.customClaim"
              :tag-name="isZh?'chineseName':'englishName'"
              :fields="['chineseName']"
              @parentCallBack="p=>{job.customClaim=p.value}"
            />
          </el-form-item>
          <el-form-item v-if="Number(job.customClaim) === 1" :label="$t('SeaExport.CustomsDeclarationType')">
            <cargo-advance-select
              no="71"
              filterable
              :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
              :default-value="job.customsClaim2 || 0"
              @parentCallBack="p=>{job.customsClaim2=p.value;job.customsDeclarationType=p.value}"
            />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="130px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.NotifyParty')" class="auto-width">
            <cargo-company-select
              no="72"
              :disabled="readonly"
              :method-params="{notify:true,active:true}"
              :default-value="job.notifyId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateNotifyList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="notifyChange"
            />&nbsp;
            <el-button
              no="73"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="job['notifyLine'+i]"
              no="74"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoChineseName"
              no="75"
              :disabled="!isEdit"
              :auto-half-word="false"
              :auto-uppercase="false"
              style="height: 65px;min-height: 65px;flex: 1;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val}, true, {autoUppercase:true})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoEnglishName"
              no="76"
              :text-chars="0"
              :warning-count="-1"
              :disabled="!isEdit"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 65px;min-height: 65px;flex: 1;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val}, isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')">
            <cargo-rich-textarea
              v-model="job.mark"
              no="77"
              :text-chars="0"
              :warning-count="-1"
              :disabled="!isEdit"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 65px;min-height: 65px;flex: 1;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
            <cargo-advance-select
              no="78"
              :select-type="TYPE_NAMES.basic_data_CargoInformation"
              filterable
              :callback-params="{key:'cargoCode'}"
              :default-value="job.cargoCode"
              :placeholder="$t('queryJob.ClickSelectTheGoodsCode')"
              @parentCallBack="txtCargoInformationChangeHandler"
            />
          </el-form-item>
          <el-form-item>
            <el-input v-model="job.cargoName" no="79" :disabled="!job.cargoCode" />
          </el-form-item>
          <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.HaulageCompany')">
            <cargo-company-select
              no="80"
              :disabled="!job.landTransportation"
              :method-params="{truckCmp:true,active:true}"
              :default-value="job.carryingCmp||''"
              :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
              @change="carryingCmpChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SellingPrice')">
            <el-input v-model="job.selling" no="81" @blur="sellingOrBuyingChangeHandler" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BuyingPrice')">
            <el-input v-model="job.buying" no="82" @blur="sellingOrBuyingChangeHandler" />
          </el-form-item>
          <el-form-item v-show="job.loadingTerm==='DD'" :label="$t('SeaExport.Door')">
            <el-select
              v-model="truckingInfo.doorName"
              no="83"
              value-key="name"
              clearable
              filterable
              :allow-create="true"
              @change="doorsChangeHandler"
            >
              <el-option
                v-for="(item,index) in doorList"
                :key="index"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-show="job.loadingTerm==='DD'" :label="$t('Payment.contactPerson')">
            <div style="display: flex">
              <el-input v-model="truckingInfo.doorMan" no="84" class="short-el-input" :placeholder="$t('Payment.contactPerson')" />
              <div style="width: 65px;padding:0 10px;font-size: 12px;">{{ $t('SeaExport.Tel') }}</div>
              <el-input v-model="truckingInfo.doorManTel" no="85" class="short-el-input" :placeholder="$t('SeaExport.Tel')" />
            </div>
          </el-form-item>
          <el-form-item v-show="job.loadingTerm==='DD'" :label="$t('SeaExport.DoorAddress')">
            <el-input v-model="truckingInfo.doorAddr" no="86" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfDestinationServices')">
            <el-checkbox
              v-model="job.dischargingPortDoor"
              no="dischargingPortDoor"
              style="display: block;"
            >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-checkbox
              v-model="job.usCustomsClearance"
              no="usCustomsClearance"
              style="display: block;"
            >{{ $t('queryJob.UsCustomsClearance') }}
            </el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
            <cargo-company-select
              no="exChangeAgent"
              :disabled="!job.dischargingPortDoor"
              :method-params="{bookingAgent:true,active:true}"
              :default-value="job.exChangeAgent||''"
              @change="onExChangeAgentChange"
            />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="100px"
          label-position="left"
        >
          <el-form-item :label="$t('SeaExport.SecondNotifyParty')" class="auto-width">
            <cargo-rich-textarea
              v-model="job.alsoNotify"
              no="87"
              :disabled="readonly"
              :text-chars="0"
              style="width: 260px;height: 216px;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),job.alsoNotify,val=>{job.alsoNotify=val},true,{warningCount:45,maxChar: 0})"
            />
          </el-form-item>
          <el-form-item class="auto-width">
            <special-requests-grid
              ref="selectedSpecialRequest"
              v-model="job.satisfiedRequests"
              no="88"
              :is-edit="isEdit"
              :customer-id="job.customerId"
              :lob="job.lob"
              :job="job"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Remarks')" class="auto-width">
            <el-input
              v-model="job.remarks"
              no="89"
              type="textarea"
              :rows="4"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField1')" class="auto-width">
            <el-input v-model="job.userDefinedField1" no="90" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField2')" class="auto-width">
            <el-input v-model="job.userDefinedField2" no="91" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField3')" class="auto-width">
            <el-input v-model="job.userDefinedField3" no="92" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField4')" class="auto-width">
            <el-input v-model="job.userDefinedField4" no="93" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TaxNature')">
            <el-select
              v-model="job.taxNature"
              no="taxNature"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in TAX_NATURES"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>&nbsp;
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :own-permission="hasChooseOwnTransceiverPermission"
      :customer-cmp-list="customerCmpList"
      :use-empty-customer-cmp-list="true"
      @callback="codeSearchCallback"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 中转信息弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="transitPortDialog.visible"
      :title="$t('SeaExport.TransitInformation')"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="transit-port-dialog"
    >
      <el-row :gutter="20">
        <el-col :span="10" :offset="4" style="font-weight: bold;text-align: center;">{{ $t('SeaExport.SecondCheck') }}</el-col>
        <el-col :span="10" style="font-weight: bold;text-align: center;">{{ $t('SeaExport.ThreeWay') }}</el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 5px;">
        <el-col :span="4">To</el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="94"
            filterable
            :select-type="TYPE_NAMES.basic_data_Airport"
            :default-value="transitPortDialog.form.secondPortCode"
            @parentCallBack="p=>{transitPortDialog.form.secondPortCode=p.value}"
          />
        </el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="95"
            filterable
            :select-type="TYPE_NAMES.basic_data_Airport"
            :default-value="transitPortDialog.form.thirdPortCode"
            @parentCallBack="p=>{transitPortDialog.form.thirdPortCode=p.value}"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="4">By</el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="96"
            filterable
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            :default-value="transitPortDialog.form.secondCarrierId||''"
            @parentCallBack="p=>{transitPortDialog.form.secondCarrierIdd=p.value||0}"
          />
        </el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="97"
            filterable
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            :default-value="transitPortDialog.form.thirdCarrierId||''"
            @parentCallBack="p=>{transitPortDialog.form.thirdCarrierId=p.value||0}"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="4">Flight</el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.secondFlight" no="98" />
        </el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.thirdFlight" no="99" />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="4">MAWB</el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.secondMAWB" no="100" />
        </el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.thirdMAWB" no="101" />
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="102"
          type="primary"
          @click="confirmTransitPort"
        >{{ $t('common.btn.ok') }}</el-button>
        <el-button no="103" @click="transitPortDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tabAeBookingJS from './tabAeBooking.js'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/BookingTerm'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { Trucking } from '@/class/model/booking/Trucking'
import cargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { SPLIT_BUBBLE_COLLECT_ITEMS, SELL_BUY_PRICE } from '@/class/cargo/model/parameters/AirExportConstants'
import { RATE_TYPE, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabAeBooking',
  components: {
    cargoAdvanceSelect, cargoCompanySelect, cargoUserSelect, cargoDepartmentSelect, cargoDepartmentNewSelect, cargoSalesCompanySelect,
    cargoInput, cargoRichTextarea, cargoPackingSelect, cargoProjectSelect, billAddressDialog, bookingSeaEqDataGrid, specialRequestsGrid, AutoNumberInput
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      accountObjectControlMode: 0,
      SPLIT_BUBBLE_COLLECT_ITEMS,
      SELL_BUY_PRICE,
      currentOffice: {},
      salesOfficeCheck: false, // 是否按照分公司控制 (0:开启分公司过滤 1:关闭分公司过滤)
      validateCustomerSales: false,
      isSpecifiedSalesBusiness: false,
      salesCanSeeBookingAgent: false,
      openProjectConfig: false,
      TAX_NATURES,
      rateType: RATE_TYPE,
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      splitBubbleCollectionFormat: false, // 分泡收取格式
      pbProportionCheck: false,
      pbProportion2Check: false,
      isHc: false,
      addrPM: new BillAddressCommonPM(this),
      job: new AirExportJob().fillDefaultValue().getData(),
      truckingInfo: new Trucking().fillDefaultValue().getData(),
      customerCmpList: null,
      contactList: [],
      csrList: null,
      cargoSalesList: null,
      salesList: null,
      lockSales: false,
      openImperial: false, // 是否开启英制单位
      txtSalesOffice: '', // 销售所在分公司,
      dcList: null,
      doorList: [],
      billAddressDialog: {
        visible: false
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoUppercase: false
        }
      },
      transitPortDialog: {
        visible: false,
        form: {
          secondPortCode: '',
          secondCarrierId: '',
          secondFlight: '',
          secondMAWB: '',
          thirdPortCode: '',
          thirdCarrierId: '',
          thirdFlight: '',
          thirdMAWB: ''
        }
      },
      selectTypeNames: TYPE_NAMES,
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      needConfirmProjectNo: false,
      poNoRed: false,
      isProjectLinkedCustomer: false,
      privateShipperList: [], // 当前登录用户服务人员是自己的发货人列表
      privateConsigneeList: [], // 当前登录用户服务人员是自己的收货人列表
      privateNotifyList: [], // 当前登录用户服务人员是自己的通知人列表
      hasChooseOwnTransceiverPermission: false, // 是否有选择自己作为收发通的权限
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cWeightCeil: 0,
      creditOpen: false, // 是否开启信控
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isShowContactPersonDetail: false, // 海创显示详细信息
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    electricBusinessBtnEnable() {
      return !this.$checkPermission(['role_ElectricBusiness']) || this.context.user.admin
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    }
  },
  async created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.bookingTerms = BOOKING_TERMS
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
    this.isUppercaseByConfig = await JobUtils.uppercaseCargoEnglishNameAndMark()
  },
  methods: tabAeBookingJS.methods
}
</script>

<style scoped lang="scss">
#app .section.top::v-deep {
  .job-no-color.el-input {
    .el-input__inner {
      background: #ffffcc !important;
    }
  }
  .el-form-item__content {
    display: inline-block;
    flex-direction: unset;
  }
}
#app .section ::v-deep {
  .el-form-item__content {
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    .el-date-editor {
      width: 100%;
    }
    .short-item-input{
      width: 360px;
      display: inline-block;
      &::after{
        clear: both;
      }
      label{
        float: left;
        width: 65px;
        height: 31px;
        line-height: 31px;
        font-weight: normal;
        text-align: right;
        padding-right: 5px;
        box-sizing: border-box;
        &:nth-of-type(1){
          width: 100px;
          text-align: left;
        }
      }
      .short-input{
        float: left;
        width: 95px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid #DCDFE6;
        background-color: #fff;
        .el-input{
          vertical-align: middle;
          input{
            width: 63px;
            border: none;
          }
        }
        & > span{
          width: 30px;
          vertical-align: middle;
          padding: 1px 3px 0 0;
          color: #999;
          font-size: 12px;
        }
        &:nth-of-type(1){
          margin-right: 5px;
        }
      }
      .short-input-disabled{
        background-color: #f3f4f5;
      }
    }
    input{
      width: 260px;
    }
    .shipper-input{
      width: 190px;
      margin-right: 5px;
      display: inline-block;
      .cargo-advance-select-wrapper{
        width: 190px;
        input{
          width: 190px;
        }
      }
    }
    .shipper-input-en{
      width: 148px;
      margin-right: 5px;
      display: inline-block;
      .cargo-advance-select-wrapper{
        width: 148px;
        input{
          width: 148px;
        }
      }
    }
    .short-el-input{
      width: 100px;
      input{
        width: 100px;
      }
    }
    .port-item{
      input{
        width: 100%;
      }
    }
  }
  .form-item-w260 {
    .el-form-item__content {
      width: 260px;
    }
  }
  .auto-width {
    .el-form-item__content {
      width: auto;
    }
  }
  .el-checkbox {
    margin-right: 15px;
  }
  .el-radio-group{
    white-space: normal;
    .el-radio {
      margin-right: 15px;
      padding: 5px 0;
    }
  }
}
.transit-port-dialog ::v-deep {
  .el-select {
    width: 100%;
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
